import { render, staticRenderFns } from "./TemplateGallery.vue?vue&type=template&id=6292d664&scoped=true&"
import script from "./TemplateGallery.vue?vue&type=script&lang=js&"
export * from "./TemplateGallery.vue?vue&type=script&lang=js&"
import style0 from "./TemplateGallery.vue?vue&type=style&index=0&id=6292d664&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6292d664",
  null
  
)

export default component.exports